(function () {
  'use strict';

  var el = document.getElementById('flg-metaobject-search');
  if (!el) return;

  var SHOP = el.dataset.shop;
  var TOKEN = el.dataset.token;
  var API_URL = 'https://' + SHOP + '/api/2025-01/graphql.json';
  var HEADERS = {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': TOKEN
  };

  var artistCache = null;
  var exhibitionCache = null;
  var prefetchStarted = false;
  var prefetchDone = false;
  var currentTerm = '';

  /* Track actual DOM nodes and their observers */
  var tracked = {
    artists:     { div: null, observer: null },
    exhibitions: { div: null, observer: null }
  };

  /* ── API ── */

  function gql(query) {
    return fetch(API_URL, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ query: query })
    }).then(function (r) { return r.json(); });
  }

  function fetchAllPages(type, fieldKey, cache, onPage) {
    function mapNodes(nodes) {
      return nodes
        .filter(function (n) { return n.field && n.field.value; })
        .map(function (n) {
          return { label: n.field.value, url: n.onlineStoreUrl || '/pages/' + n.handle };
        });
    }

    function fetchPage(cursor) {
      var after = cursor ? ', after: "' + cursor + '"' : '';
      var query = [
        '{ metaobjects(type: "' + type + '", first: 250' + after + ') {',
        '    nodes {',
        '      handle',
        '      onlineStoreUrl',
        '      field(key: "' + fieldKey + '") { value }',
        '    }',
        '    pageInfo { hasNextPage endCursor }',
        '  }',
        '}'
      ].join('\n');

      return gql(query).then(function (data) {
        var result = data.data && data.data.metaobjects;
        if (!result) return;

        var items = mapNodes(result.nodes || []);
        for (var i = 0; i < items.length; i++) cache.push(items[i]);

        onPage();

        if (result.pageInfo && result.pageInfo.hasNextPage && result.pageInfo.endCursor) {
          return fetchPage(result.pageInfo.endCursor);
        }
      });
    }

    return fetchPage(null);
  }

  function prefetch() {
    if (prefetchStarted) return;
    prefetchStarted = true;

    artistCache = [];
    exhibitionCache = [];
    prefetchDone = true;

    function onPage() {
      if (currentTerm) fill();
    }

    fetchAllPages('artists', 'name', artistCache, onPage);
    fetchAllPages('exhibitions', 'title', exhibitionCache, onPage);
  }

  /* ── FILTER ── */

  function filterCache(cache, term) {
    if (!cache || !cache.length || !term) return [];
    var lower = term.toLowerCase();
    return cache.filter(function (item) {
      return item.label.toLowerCase().indexOf(lower) !== -1;
    });
  }

  /* ── DOM ── */

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function buildList(heading, items) {
    var html = '<div class="quick-search__sidebar-item">';
    html += '<h4 class="quick-search__header">' + heading + ' (' + items.length + ')</h4>';
    html += '<ul class="quick-search__sidebar-list reset">';
    for (var i = 0; i < items.length; i++) {
      html += '<li class="quick-search__sidebar-list-item fancy-link">';
      html += '<a href="' + escapeHtml(items[i].url) + '">' + escapeHtml(items[i].label) + '</a>';
      html += '</li>';
    }
    html += '</ul></div>';
    return html;
  }

  /* ── FILL ── */

  function fillDiv(div, cache, heading) {
    if (!div) return;
    if (!currentTerm || !prefetchDone) {
      div.innerHTML = '';
      return;
    }
    var items = filterCache(cache, currentTerm).slice(0, 10);
    div.innerHTML = items.length ? buildList(heading, items) : '';
  }

  function ensureObserver(key, div, cache, heading) {
    var t = tracked[key];

    /* Same DOM node — observer still valid */
    if (t.div === div) return;

    /* New or replaced node — disconnect old, attach new */
    if (t.observer) t.observer.disconnect();

    t.div = div;
    t.observer = new MutationObserver(function () {
      if (div.children.length === 0 && currentTerm && prefetchDone) {
        fillDiv(div, cache, heading);
      }
    });
    t.observer.observe(div, { childList: true });
  }

  function fill() {
    var artistDiv = document.getElementById('flg-mo-artists');
    var exhibitionDiv = document.getElementById('flg-mo-exhibitions');

    if (artistDiv) ensureObserver('artists', artistDiv, artistCache, 'Artists');
    if (exhibitionDiv) ensureObserver('exhibitions', exhibitionDiv, exhibitionCache, 'Exhibitions');

    fillDiv(artistDiv, artistCache, 'Artists');
    fillDiv(exhibitionDiv, exhibitionCache, 'Exhibitions');
  }

  /* ── INIT ── */

  function init() {
    var searchInput = document.querySelector('[data-quick-search-input]');
    if (!searchInput) return;

    searchInput.addEventListener('focus', prefetch, { once: true });

    var fillTimer = null;

    searchInput.addEventListener('input', function () {
      currentTerm = searchInput.value.trim();
      fill();

      /*
       * Safety net: re-fill 500ms after each keystroke.
       * By then the theme's fetch + morph cycle is complete.
       * Catches any case where morph replaced the divs and
       * the observer couldn't fire.
       */
      clearTimeout(fillTimer);
      fillTimer = setTimeout(fill, 500);
    });

    var resetBtn = document.querySelector('[data-quick-search-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        currentTerm = '';
        clearTimeout(fillTimer);
        fill();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();